import { useMediaQuery } from '@material-ui/core';
import { useMemo } from 'react';
export function useAcsFormFactor(downBreakpoint = 'md') {
    const isDown = useMediaQuery((theme) => theme.breakpoints.down(downBreakpoint));
    return useMemo(() => {
        return isDown ? 'mobile' : 'desktop';
    }, [isDown]);
}
